import { useMsal } from '@azure/msal-react';
import { useAppConfig } from '../appConfig';
import { useLoginRequest } from './useLoginRequest';
/** Hook that returns a pre-configured sign in handler */
export const useSignInFunction = () => {
    const { instance } = useMsal();
    const { usePopupFlow } = useAppConfig();
    const loginRequest = useLoginRequest();
    return (options) => {
        if (usePopupFlow) {
            return instance.loginPopup(Object.assign(Object.assign({}, loginRequest), options));
        }
        else {
            return instance.loginRedirect(Object.assign(Object.assign({}, loginRequest), options));
        }
    };
};
